export default {
  BOOKER: 'booker',
  HOSTER: 'hoster',
};
